import { render, staticRenderFns } from "./passage.vue?vue&type=template&id=7cb3c18e"
import script from "./passage.vue?vue&type=script&lang=js"
export * from "./passage.vue?vue&type=script&lang=js"
import style0 from "./passage.vue?vue&type=style&index=0&id=7cb3c18e&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports